import React, { useEffect, useState } from 'react';

/**
 * OAuth Error Callback Page
 * Displays error message when OAuth authentication fails
 */
const OAuthError = () => {
  const [errorMessage, setErrorMessage] = useState('Authentication failed');

  useEffect(() => {
    // Extract error from URL
    const params = new URLSearchParams(window.location.search);
    const error = params.get('error');
    
    const errorMessages = {
      'invalid_state': 'Invalid authentication state. Please try again.',
      'email_required': 'Email permission is required to create an account.',
      'google_auth_failed': 'Google authentication failed. Please try again.',
      'facebook_auth_failed': 'Facebook authentication failed. Please try again.',
      'apple_auth_failed': 'Apple authentication failed. Please try again.'
    };

    setErrorMessage(errorMessages[error] || 'Authentication failed. Please try again.');

    // Auto-close after 5 seconds
    setTimeout(() => {
      window.close();
    }, 5000);
  }, []);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontFamily: 'sans-serif',
      backgroundColor: '#fef2f2'
    }}>
      <div style={{ textAlign: 'center', maxWidth: '400px', padding: '24px' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>❌</div>
        <h2 style={{ color: '#dc2626', marginBottom: '12px' }}>Authentication Failed</h2>
        <p style={{ color: '#64748b', marginBottom: '24px' }}>{errorMessage}</p>
        <button
          onClick={() => window.close()}
          style={{
            padding: '10px 20px',
            backgroundColor: '#dc2626',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Close Window
        </button>
      </div>
    </div>
  );
};

export default OAuthError;
